import React, { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import { Notice } from '../components/Shared';

export default function Auth() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get('mode') === 'signup' ? 'signup' : 'login');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const { session } = useAuth();

  if (session) return <Navigate to="/account" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    const form = Object.fromEntries(new FormData(event.currentTarget));
    if (!supabase) {
      setMessage('Supabase is not configured. Add your project URL and anonymous key.');
      setBusy(false);
      return;
    }
    const action = mode === 'signup'
      ? supabase.auth.signUp({ email: form.email, password: form.password, options: { data: { full_name: form.full_name } } })
      : supabase.auth.signInWithPassword({ email: form.email, password: form.password });
    const { error } = await action;
    setBusy(false);
    setMessage(error ? error.message : mode === 'signup' ? 'Check your email to verify your account.' : 'Signed in successfully.');
  };

  const resetPassword = async () => {
    const email = document.querySelector('[name=email]')?.value;
    if (!email) return setMessage('Enter your email address first.');
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${window.location.origin}/#/login` });
    setMessage(error?.message || 'Password reset instructions have been sent.');
  };

  return (
    <section className="auth-page">
      <div className="auth-card">
        <span className="eyebrow">{mode === 'login' ? 'Welcome back' : 'Start your growth journey'}</span>
        <h1>{mode === 'login' ? 'Sign in to your account' : 'Create your account'}</h1>
        <p>Access your subscription, invoices, support and coaching activation.</p>
        <form onSubmit={submit}>
          {mode === 'signup' && <label>Full name<input name="full_name" autoComplete="name" required /></label>}
          <label>Email address<input name="email" type="email" autoComplete="email" required /></label>
          <label>Password<input name="password" type="password" autoComplete={mode === 'signup' ? 'new-password' : 'current-password'} minLength="8" required /></label>
          <button className="button full" disabled={busy}>{busy ? 'Please wait…' : mode === 'login' ? 'Sign In' : 'Create Account'}</button>
        </form>
        {message && <Notice type={message.includes('success') || message.includes('sent') || message.includes('Check') ? 'success' : 'error'}>{message}</Notice>}
        {mode === 'login' && <button className="text-button" onClick={resetPassword}>Forgot your password?</button>}
        <button className="text-button" onClick={() => setMode(mode === 'login' ? 'signup' : 'login')}>
          {mode === 'login' ? 'New here? Create an account' : 'Already have an account? Sign in'}
        </button>
      </div>
    </section>
  );
}